module.exports = __webpack_public_path__ + "img/rtemplum64_ua.7679f27f.webp";